import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import ListingsModal from 'views/V2/Integration/components/ListingsModal';
import ListingsTable from 'views/V2/Integration/components/ListingsTable';

import classes from './confirmMoveListings.module.css';

const ConfirmMoveListings = ({ data, open, onClose, onConfirm, onCancel, onDeleteAction }) => {
    const { header, rows, brandName } = data;

    return (
        <ListingsModal open={open} onClose={onClose} className={classes.container}>
            <ListingsModal.Header title="Confirmation" onClose={onClose} />
            <ListingsModal.Content>
                <Box className={classes.contentWrapper}>
                    <Typography className={classes.text}>
                        Are you sure you want to move the{' '}
                        {rows?.length > 1 ? 'listings' : 'listing'} below to{' '}
                        <b className={classes.brandName}>{brandName}</b>?
                    </Typography>
                    <ListingsTable
                        header={header}
                        rows={rows}
                        onDelete={onDeleteAction}
                        noDataMessage={
                            'No listings to be moved. Please select at least one listing.'
                        }
                    />
                </Box>
            </ListingsModal.Content>
            <ListingsModal.Footer
                primaryBtnProps={{
                    title: 'Confirm',
                    onClick: onConfirm,
                    disabled: rows?.length === 0,
                }}
                secondaryBtnProps={{
                    title: 'Cancel',
                    onClick: onCancel,
                }}
            />
        </ListingsModal>
    );
};

ConfirmMoveListings.propTypes = {
    data: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    onDeleteAction: PropTypes.func,
};
export default ConfirmMoveListings;
